import React from 'react'
import { bindActionCreators } from 'redux'
import { connect } from 'react-redux'
import ErrorMessage from '../components/ErrorMessage'
import LoadingProgress from '../components/LoadingProgress'
import Calendar from '../components/Calendar'; // Import the Calendar component
import { fetchCalendar } from '../actions/calendars'
import { fetchCustomer } from '../actions/customers'
import CalendarPricesAddForm from '../forms/CalendarPricesAddForm'
import '../styles/CalendarDetailsView.css'

class CalendarDetailsView extends React.Component {
  constructor(props) {
    super(props);
    const currentYear = new Date().getFullYear();
    this.state = {
      startMonth: 10,
      endMonth: 3,
      startYear: currentYear,
      endYear: currentYear,
      minYear: currentYear,
      maxYear: currentYear,
    };
  }

  componentDidMount() {
    const { fetchCalendar, fetchCustomer } = this.props;

    fetchCalendar(this.props.match.params.id).then(response => {

      fetchCustomer(response.response.Customer);
    });
  }

  componentDidUpdate(prevProps) {
    if (
      this.props.calendar &&
      this.props.calendar.PriceCalendar &&
      prevProps.calendar?.PriceCalendar !== this.props.calendar.PriceCalendar &&
      this.props.calendar.PriceCalendar.length > 0
    ) {
      const dates = this.props.calendar.PriceCalendar.map(entry => new Date(entry.date));

      const minDate = new Date(Math.min(...dates));
      const maxDate = new Date(Math.max(...dates));

      const minYear = minDate.getFullYear();
      const maxYear = maxDate.getFullYear();

      this.setState({
        startMonth: minDate.getMonth(),  // 0 = January
        endMonth: maxDate.getMonth(),     // 11 = December
        startYear: minYear,
        endYear: maxYear,
        minYear: minYear,
        maxYear: maxYear,
      });
    }
  }

  handleMonthChange = (event) => {
    const { name, value } = event.target;
    this.setState({ [name]: parseInt(value) });
  };

  handleYearChange = (event) => {
    const { name, value } = event.target;
    this.setState({ [name]: parseInt(value) });
  };

  render() {
    const { calendar, error, loading } = this.props;
    const { startMonth, endMonth, startYear, endYear, minYear, maxYear } = this.state;

    if (error) {
      return <ErrorMessage message={error.message} />;
    }

    if (!calendar || loading) {
      return <LoadingProgress />;
    }

    const monthNames = [
      'Enero', 'Febrero', 'Marzo', 'Abril', 'Mayo', 'Junio',
      'Julio', 'Agosto', 'Septiembre', 'Octubre', 'Noviembre', 'Diciembre'
    ];

    // Generate array of years from minYear to maxYear
    const availableYears = [];
    for (let year = minYear; year <= maxYear; year++) {
      availableYears.push(year);
    }

    const datesForRange = (calendar.PriceCalendar || []).map(pc => new Date(pc.date)).filter(d => !isNaN(d)).sort((a,b)=>a-b)
    const startDateLabel = datesForRange.length ? datesForRange[0].toLocaleDateString('es-ES', { day: 'numeric', month: 'short', year: 'numeric' }) : '—'
    const endDateLabel = datesForRange.length ? datesForRange[datesForRange.length-1].toLocaleDateString('es-ES', { day: 'numeric', month: 'short', year: 'numeric' }) : '—'
    const entriesCount = (calendar.PriceCalendar || []).length

    const priceValues = (calendar.PriceCalendar || []).reduce((acc, pc) => {
      if (pc.prices && pc.prices.length) pc.prices.forEach(p => { if (p && typeof p.price === 'number') acc.push(p.price) })
      return acc
    }, [])
    const minPrice = priceValues.length ? Math.min(...priceValues) : null
    const maxPrice = priceValues.length ? Math.max(...priceValues) : null
    const avgPrice = priceValues.length ? (priceValues.reduce((s,v)=>s+v,0)/priceValues.length) : null
    const fmt = v => v === null ? '—' : v.toLocaleString('es-ES', { style: 'currency', currency: 'EUR' })

    return (
      <div className="calendar-details-view">
        <div className="calendar-details-header mb-3">
          <div className="calendar-details-title">
            <h1 className="m-0">
              <i className="fas fa-calendar-alt mr-2"></i>
              <span className="text-vw-light">CALENDARIO</span>
              <span className="text-vw-dark"> {calendar.Name}</span>
            </h1>
          </div>
          <div className="calendar-details-actions d-flex align-items-center">
            <div className="text-muted small">{entriesCount} días · Rango: {startDateLabel} — {endDateLabel}</div>
          </div>
        </div>

        <div className="row mb-3">
          <div className="col-xs-12 col-sm-4 col-md-3">
            <div className="card-section">
              <div className="card-header-custom bg-vw-light"><i className="fas fa-calendar-alt mr-2"></i>Meses a mostrar</div>
              <div className="card-body-custom">
                <div>
                  <div className="col mb-3">
                    <h6 className="text-dark">Mes de Inicio</h6>
                    <div className="row">
                      <div className="col-7 pr-1">
                        <select className="form-control false" name="startMonth" value={startMonth} onChange={this.handleMonthChange}>
                          {monthNames.map((monthName, index) => (
                            <option key={index} value={index}>{monthName}</option>
                          ))}
                        </select>
                      </div>
                      <div className="col-5 pl-1">
                        <select className="form-control false" name="startYear" value={startYear} onChange={this.handleYearChange}>
                          {availableYears.map((year) => (
                            <option key={year} value={year}>{year}</option>
                          ))}
                        </select>
                      </div>
                    </div>
                  </div>
                  <div className="col">
                    <h6 className="text-dark">Mes de Fin</h6>
                    <div className="row">
                      <div className="col-7 pr-1">
                        <select className="form-control false" name="endMonth" value={endMonth} onChange={this.handleMonthChange}>
                          {monthNames.map((monthName, index) => (
                            <option key={index} value={index}>{monthName}</option>
                          ))}
                        </select>
                      </div>
                      <div className="col-5 pl-1">
                        <select className="form-control false" name="endYear" value={endYear} onChange={this.handleYearChange}>
                          {availableYears.map((year) => (
                            <option key={year} value={year}>{year}</option>
                          ))}
                        </select>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div className="col-xs-12 col-sm-8 col-md-9">
            <div className="card-section">
              <div className="card-header-custom bg-vw-dark"><i className="fas fa-edit mr-2"></i>Formulario de actualización de precios</div>
              <div className="card-body-custom">
                <CalendarPricesAddForm
                  customer={this.props.customer}
                  calendar={calendar}
                />
              </div>
            </div>
          </div>
        </div>

        <div className="row mb-3">
          <div className="col">
            <div className="card-section">
              <div className="card-header-custom"><i className="fas fa-calendar-day mr-2"></i>Vista de calendario</div>
              <div className="card-body-custom">
                <div className="calendar-detail-summary mb-3 d-flex align-items-center" style={{gap: '12px', flexWrap: 'wrap'}}>
                  <span className="badge badge-light">Días: {entriesCount}</span>
                  <span className="text-muted">Rango: {startDateLabel} — {endDateLabel}</span>
                  <span className="price-summary">{`Min ${fmt(minPrice)} · Avg ${fmt(avgPrice)} · Max ${fmt(maxPrice)}`}</span>
                </div>

                <Calendar
                  startYear={startYear}
                  endYear={endYear}
                  priceCalendar={calendar.PriceCalendar}
                  startMonth={startMonth}
                  endMonth={endMonth}
                  customer={this.props.customer}
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

const mapStateToProps = state => ({
  calendar: state.calendars.calendar,
  customer: state.customers.customer,
  loading: state.calendars.loading,
  error: state.calendars.error,
});

const mapDispatchToProps = dispatch => ({
  fetchCalendar: bindActionCreators(fetchCalendar, dispatch),
  fetchCustomer: bindActionCreators(fetchCustomer, dispatch)
});

export default connect(mapStateToProps, mapDispatchToProps)(CalendarDetailsView);
